import { globalTheme } from '@clds/component-theme';
import { HTMLInput, TextInput as Input, Root } from '@clds/input';
import styled from 'styled-components';

const StyledRoot = styled(Root)`
  /* Increase specificity to win with design system colors */
  && {
    background: ${globalTheme.palette.surface};
  }
`;

const StyledHTMLInput = styled(HTMLInput)`
  background-color: transparent;
  border-color: transparent;

  &#adv-public-id::placeholder {
    color: ${globalTheme.palette.secondary};
    opacity: 1;
  }
`;

export const TextInput = ({ slots, ...props }) => (
  <Input
    slots={{
      ...slots,
      root: StyledRoot,
      input: StyledHTMLInput,
    }}
    {...props}
  />
);
